import { FC } from 'react';

import { Icon } from '@purpur/library/icon';
import { arrowRight } from '@purpur/library/icon/assets/arrow-right';

import { CtaProvider } from '../CtaProvider/CtaProvider';
import { ValuePromptItem } from './model';
import {
    ValuePromptButtonCTA,
    ValuePromptContainerCompact,
    ValuePromptContainerIllustrative,
    ValuePromptCTA,
    ValuePromptHeading,
    ValuePromptImageCompact,
    ValuePromptImageIllustrative,
    ValuePromptParagraph,
} from './ValuePrompt.styles';

export const ValuePrompt: FC<ValuePromptItem> = ({ variant, colorVariant, img, heading, text, cta }) => {
    const trackingAttributes = {
        'data-section': 'Value Prompt',
        'data-section-name': heading.title,
        'data-section-color-option': colorVariant,
    };

    return variant === 'compact' ? (
        <ValuePromptContainerCompact $colorVariant={colorVariant} {...trackingAttributes}>
            {img && <ValuePromptImageCompact src={img.src} alt={img.alt} loading="lazy" />}
            <div>
                <ValuePromptHeading variant="title-100" tag={heading.tag}>
                    {heading.title}
                </ValuePromptHeading>
                {text && <ValuePromptParagraph variant="paragraph-100">{text}</ValuePromptParagraph>}
            </div>
        </ValuePromptContainerCompact>
    ) : (
        <ValuePromptContainerIllustrative $colorVariant={colorVariant} {...trackingAttributes}>
            {img && <ValuePromptImageIllustrative src={img.src} alt={img.alt} loading="lazy" />}
            <ValuePromptHeading variant="title-100" tag={heading.tag}>
                {heading.title}
            </ValuePromptHeading>
            <ValuePromptParagraph variant="paragraph-100">{text}</ValuePromptParagraph>
            {cta && (
                <CtaProvider cta={cta}>
                    {({ href, rel, target, text: ctaText, onClick }) =>
                        href ? (
                            <ValuePromptCTA
                                variant="standalone"
                                href={href}
                                target={target}
                                rel={rel}
                                onClick={onClick}
                                disableVisited={true}
                                data-element="Link"
                                data-element-name={ctaText}
                            >
                                {ctaText}
                                <Icon svg={arrowRight} size="xs" />
                            </ValuePromptCTA>
                        ) : (
                            <ValuePromptButtonCTA
                                styledAsLink={true}
                                withPadding={true}
                                size="sm"
                                onClick={onClick}
                                data-element="Button"
                                data-element-name={ctaText}
                            >
                                {ctaText}
                                <Icon svg={arrowRight} size="xs" />
                            </ValuePromptButtonCTA>
                        )
                    }
                </CtaProvider>
            )}
        </ValuePromptContainerIllustrative>
    );
};
